import { SET_CHART_TYPE, SET_SHOW_OVER_TIME_RUNNING_SUM } from './types';
export const setChartType = (chartType) => ({
    type: SET_CHART_TYPE,
    payload: {
        chartType,
    },
});
export const setShowOverTimeRunningSum = (showOverTimeRunningSum) => ({
    type: SET_SHOW_OVER_TIME_RUNNING_SUM,
    payload: { showOverTimeRunningSum },
});
